// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__Z1Qtr","tooltip__title":"styles_tooltip__title__2CWb5","tooltip__hint":"styles_tooltip__hint__3Gfyl"};